const state = () => {
    return {
      seasonOnParcelHasCulture: [],
      spcWorks:[],
      spcWorkSummary:[],
      spcMachines:[],
      spcParcels:[],
      spcBulkWorks: [],
    }
  }

  export default state;
